import { NgModule } from '@angular/core';
import { RouterModule, Routes, Router } from '@angular/router';
import { UserLayoutComponent } from './components/user-layout/user-layout.component';
import { CartComponent } from './components/cart/cart.component';
import { WishlistComponent } from './components/wishlist/wishlist.component';
import { EnduserProfileComponent } from './components/enduser-profile/enduser-profile.component';
import { ProductDetailComponent } from '@app/shared/components/product-detail/product-detail.component';
import { SavedDesignsComponent } from './components/saved-designs/saved-designs.component';
import { UserGuard } from '@app/core/guards/user.guard';

import { PaymentfailedComponent } from './components/paymentfailed/paymentfailed.component';
// INKSOFT DISABLED (2026-09): import { InksofteditorComponent } from '@app/shared/components/inksofteditor/inksofteditor.component';
import { OrdersComponent } from '@app/shared/components/orders/list/orders.component';
import { OrderConfirmationComponent } from '@app/shared/components/orders/order-confirmation/order-confirmation.component';
import { OrderDetailComponent } from '@app/shared/components/orders/order-detail/order-detail.component';
import { OrderDetailResolver } from '@app/shared/routeresolver/order-detail.resolver';
import { AboutusComponent } from './components/aboutus/aboutus.component';
import { StoreTermsAndConditionComponent } from './components/store-terms-and-condition/store-terms-and-condition.component';
import { StorePrivacyAndPolicyComponent } from './components/store-privacy-and-policy/store-privacy-and-policy.component';
import {StoreHomepageComponent} from '@app/feature/end-user/components/store-homepage/store-homepage.component';
import {ViewstoreComponent} from '@app/feature/end-user/components/viewstore/viewstore.component';
import { InvoiceListComponent } from './components/invoice-list/invoice-list.component';
import { BraintreePaymentComponent } from './components/braintree-payment/braintree-payment.component';


const routes: Routes = [
  {
    path: '', component: UserLayoutComponent,
    children: [
      { path: '', component: StoreHomepageComponent},
      { path: 'products', component: ViewstoreComponent },
      { path: 'cart', component: CartComponent},
      { path: 'wishlist', component: WishlistComponent, canActivate: [UserGuard] },
      { path: 'orders', component: OrdersComponent, canActivate: [UserGuard] },
      { path: 'orderconfirmation/:orderno', component: OrderConfirmationComponent },
      { path: 'orderdetail/:orderno', component: OrderDetailComponent, 
              resolve: {orderDetail: OrderDetailResolver}, runGuardsAndResolvers: 'always'},
      { path: 'profile', component: EnduserProfileComponent, canActivate: [UserGuard] },
      // INKSOFT DISABLED (2026-09): end-user self-customize (InkSoft) retired — CanEndUserCustomize=0 for all stores (unreachable).
      // { path: 'product/customize', component: InksofteditorComponent, canActivate: [UserGuard] },
      { path: 'product/details', component: ProductDetailComponent },
      { path: 'saveddesigns', component: SavedDesignsComponent, canActivate: [UserGuard] },
      { path: 'invoicelist', component: InvoiceListComponent, canActivate: [UserGuard] },
      { path: 'paymentfailed', component: PaymentfailedComponent},
      { path: 'about', component: AboutusComponent },
      { path: 'terms-of-use', component: StoreTermsAndConditionComponent },
      { path: 'privacy-policy', component: StorePrivacyAndPolicyComponent },
      { path: 'payment', component: BraintreePaymentComponent },

    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class EndUserRouting {
  constructor(private router: Router) {

    router.events.subscribe((event: any) => {
      const a = $(window).height();
      const d = $('.footer').height();
      const e = a - d;
      $('.front-wrap').css('min-height', e);
    });
  }
}
